<template>
<div class="container-fluid">
	<employees-toolbar>

	</employees-toolbar>

	<collapsible-panel :always-open="true" panel-size="md">
		<template slot="panel">
			<panel-menu 
				:menu-items="tabs"
				:active-item="activeSection"
				v-on:itemClick="panelItemClick">
			</panel-menu>

		</template>
		<template slot="main">

			<div v-if="activeSection == 'All'">
				<h2>Employee Module Settings</h2>
				<p>These are your Employee module settings:</p>

				<div class="list-group mb-4">
					<a v-for="(tab,index) in tabs" v-if="index >= 0" class="list-group-item list-group-item-action" :href="'/employees/settings/'+tab.slugify()" v-on:click.prevent="panelItemClick(tab,index)">{{tab}}</a></li>
				</div>
			</div>

			<employee-classifications v-else-if="activeSection == 'Classifications'"></employee-classifications>

			<charge-out-groups v-else-if="activeSection == 'Charge Out Groups'"></charge-out-groups>
	
			<pay-adjustments v-else-if="activeSection == 'Pay Adjustments'"></pay-adjustments>

			<settings-unions v-else-if="activeSection == 'Compensation Groups/Unions'"></settings-unions>

			<timeoff-settings v-else-if="activeSection == 'Time-off Settings'"></timeoff-settings>

			<time-log-settings v-else-if="activeSection == 'Payroll Settings'"></time-log-settings>
		</template>
	</collapsible-panel>
</div>
</template>
<script type="text/javascript">
import EmployeesToolbar from "@/pages/employees/EmployeesToolbar"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"

import EmployeeClassifications from "@/pages/employees/EmployeeClassifications"
import ChargeOutGroups from "@/pages/employees/ChargeOutGroups"
import PayAdjustments from "@/pages/employees/PayAdjustments"
import SettingsUnions from "@/pages/settings/SettingsUnions"
import TimeoffSettings from "@/pages/employees/TimeoffSettings"
import TimeLogSettings from "@/pages/time_logs/TimeLogSettings"

export default {
	name: "EmployeeSettings",
	components: {
		EmployeesToolbar,
		CollapsiblePanel,
		PanelMenu,
		EmployeeClassifications,
		PayAdjustments,
		ChargeOutGroups,
		SettingsUnions,
		TimeoffSettings,
		TimeLogSettings
	},
	data() {
		return {
			tabs: [
				"Classifications",
				"Compensation Groups/Unions",
				"Charge Out Groups",
				"Pay Adjustments",
				"Time-off Settings",
				"Payroll Settings"
			],
			activeSection: "All"
		}
	},
	methods: {
		panelItemClick(item,index) {
			this.activeSection = item
			window.history.pushState({},"","/employees/settings/"+item.slugify())
		}
	},
	created() {
		if (this.$route.params.tab) {
			let slug = this.$route.params.tab

			this.activeSection = this.tabs.find(section => section.slugify() == slug)
		}
	}
}
</script>